import { useQuery } from "@tanstack/react-query";

import type { PaymentSource } from "features/payment-methods/types";

import { CUSTOMER_QUERY_KEYS } from "common/constants";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { get, HTTPError } from "common/helpers/HTTP";
import useAppStore from "common/hooks/useAppStore";

async function getSubscriptionPaymentSource(
  workspaceId: string,
  subscriptionId: string,
): Promise<PaymentSource> {
  try {
    const { payment_source: paymentSource } = await get(
      `workspaces/${workspaceId}/subscriptions/${subscriptionId}/payment-source`,
    );

    // This is a temporary fix, until the backend resolves the issue with correct caching of payment source, when the card is removed through Chargebee
    return paymentSource.type ? paymentSource : null;
  } catch (err) {
    if (err instanceof HTTPError && err.code === 404) {
      return null;
    }
    throw err;
  }
}
export default function useSubscriptionPaymentSource(subscriptionId: string) {
  const selectedWorkspace = useSelectedWorkspaceContext();

  const isPaymentMethodHidden = useAppStore(
    (state) => state.debugOptions.isPaymentMethodHidden,
  );

  const {
    data: subscriptionPaymentSource,
    isLoading: isLoadingSubscriptionPaymentSource,
  } = useQuery({
    queryKey:
      CUSTOMER_QUERY_KEYS.paymentSourceKeys.subscription(subscriptionId),
    queryFn: () =>
      getSubscriptionPaymentSource(selectedWorkspace.id, subscriptionId),
    enabled: !!subscriptionId,
  });

  return {
    subscriptionPaymentSource: isPaymentMethodHidden
      ? null
      : subscriptionPaymentSource,
    isLoadingSubscriptionPaymentSource,
  };
}
